<template>
  <div v-if="user" id="detailsUser">
    <c-card>
      <c-card-body>
        <h1>{{ fullName }}</h1>
      </c-card-body>
    </c-card>

    <c-card>
      <c-card-body>
        <table class="table">
          <tbody>
            <tr>
              <td>Email</td>
              <td>
                {{ user.username }}
                <a href="#" @click="changeEmail">(Change)</a>
              </td>
            </tr>
            <tr>
              <td>Password</td>
              <td>
                <a href="#" @click="changePasswordRequest">Change password</a>
              </td>
            </tr>
            <tr>
              <td>Multi-factor authentication</td>
              <td>
                {{ authenticatedUser.security.mfa.active ? 'Enabled' : 'Disabled' }}
                <a href="#" @click="showMfa = true">(Settings)</a>
              </td>
            </tr>
          </tbody>
        </table>
      </c-card-body>
    </c-card>

    <username-change-request
      :show="showChangeEmail"
      :user="user"
      @updateRequested="emailChangeRequested"
      @close="cancelChangeEmail"
    />

    <change-password
      :show="showChangePassword"
      :user="user"
      @updateRequested="changePasswordRequested"
      @close="cancelChangePassword"
    />

    <user-mfa :show="showMfa" @close="closeMfa" />
  </div>
</template>

<script>
import UsernameChangeRequest from '../users/components/username-change-request.vue';
import ChangePassword from '../users/components/change-password';
import { buildEndpoint } from '@/libs/buildEndPoint';
import { getRoleData } from '@/libs/user/getRoleData';
import UserMfa from '@/views/users/components/mfaSetup.vue';

export default {
  components: {
    UserMfa,
    UsernameChangeRequest,
    ChangePassword,
  },

  data() {
    return {
      error: null,
      user: null,
      showMfa: false,
      showChangeEmail: false,
      showChangePassword: false,
      roleData: null,
      isResendingConfirmationEmail: false,
      fullName: null,
    };
  },

  computed: {
    authenticatedUser() {
      return this.$store.state?.app?.authenticatedUser;
    },
  },

  created() {
    this.get();
  },

  methods: {
    changeEmail() {
      this.showChangeEmail = true;
    },
    closeMfa() {
      this.showMfa = false;
    },
    cancelChangeEmail() {
      this.showChangeEmail = false;
    },
    emailChangeRequested() {
      this.showChangeEmail = false;
    },
    cancelChangePassword() {
      this.showChangePassword = false;
    },
    changePasswordRequested() {
      this.showChangePassword = false;
    },
    get() {
      this.$http
        .get(buildEndpoint('my-account/get/') + this.$store.state.app.authenticatedUser.id)
        .then((response) => {
          this.error = null;
          if (response.data.success) {
            this.user = response.data.data.user;
            this.fullName = [this.user.firstName, this.user.lastName].join(' ');
            this.roleData = getRoleData(this.user.role);
          } else {
            this.error = 'Error getting data';
          }
        })
        .catch((error) => {
          this.error = error;
        });
    },
    changePasswordRequest() {
      this.showChangePassword = true;
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  tr {
    td {
      &:first-child {
        font-weight: bold;
        width: 250px;
      }
    }
  }
}
</style>
